import React from "react";
import { Box, Typography } from "@mui/material";

const userAnimations = `
  @keyframes scan-vertical {
    0% { transform: translateY(-5px); opacity: 0; }
    50% { opacity: 1; }
    100% { transform: translateY(15px); opacity: 0; }
  }
  @keyframes float-user {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-8px); }
  }
  @keyframes pulse-soft {
    0% { transform: scale(0.95); opacity: 0.5; }
    50% { transform: scale(1.05); opacity: 0.8; }
    100% { transform: scale(0.95); opacity: 0.5; }
  }
`;

const NoUserFound = () => {
  return (
    <Box
      sx={{
        height: "80vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#F8FAFC",
        borderRadius: 4,
        position: "relative",
        overflow: "hidden",
        border: "1px solid #E2E8F0",
      }}
    >
      <style>{userAnimations}</style>

      {/* Animated User SVG Icon */}
      <Box
        sx={{
          position: "relative",
          mb: 3,
          animation: "float-user 4s ease-in-out infinite",
        }}
      >
        <svg
          width="80"
          height="80"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#94A3B8"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {/* User Head & Shoulders */}
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />

          {/* The "Not Found" X overlay */}
          <line
            x1="18"
            y1="8"
            x2="22"
            y2="12"
            stroke="#2563EB"
            strokeWidth="2"
          />
          <line
            x1="22"
            y1="8"
            x2="18"
            y2="12"
            stroke="#2563EB"
            strokeWidth="2"
          />

          {/* Scanning Line Effect */}
          <rect
            x="4"
            y="10"
            width="16"
            height="0.5"
            fill="#2563EB"
            style={{ animation: "scan-vertical 2s linear infinite" }}
          />
        </svg>

        {/* Backdrop Pulse */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: 90,
            height: 90,
            bgcolor: "rgba(37, 99, 235, 0.08)",
            borderRadius: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: -1,
            animation: "pulse-soft 3s ease-in-out infinite",
          }}
        />
      </Box>

      {/* Text Content */}
      <Box sx={{ textAlign: "center", zIndex: 1 }}>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 900,
            color: "#0F172A",
            letterSpacing: "2.5px",
            textTransform: "uppercase",
            mb: 1,
          }}
        >
          User Not Located
        </Typography>

        <Box
          sx={{
            height: "2px",
            width: "30px",
            bgcolor: "#2563EB",
            margin: "0 auto 16px",
          }}
        />

        <Typography
          sx={{
            fontSize: "11px",
            color: "#64748B",
            fontWeight: 700,
            maxWidth: "260px",
            lineHeight: 1.6,
            letterSpacing: "0.5px",
            textTransform: "uppercase",
          }}
        >
          System could not identify any active identity matching your search
          criteria.
        </Typography>
      </Box>

      {/* Technical Metadata Footer */}
      <Box
        sx={{
          position: "absolute",
          bottom: 25,
          left: 25,
          opacity: 0.4,
          fontFamily: "monospace",
          fontSize: "8px",
          color: "#475569",
          lineHeight: 1.8,
        }}
      >
        SEARCH_TYPE: UID_DIRECTORY
        <br />
        MATCH_STRENGTH: 0%
        <br />
        ERROR_CODE: ERR_USER_NULL
      </Box>
    </Box>
  );
};

export default NoUserFound;
